import { createAction } from "@reduxjs/toolkit";

export const playerActions = {
  start: createAction("player/start"),
  stop: createAction("player/stop"),
};
